import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

const STATUS_ICONS = {
  MISMATCH: { icon: fas.faTimes, color: 'red' },
  MISSING: { icon: fas.faExclamationTriangle, color: 'orange' },
  ONLY_LEFT: { icon: fas.faArrowLeft, color: 'orange' },
  ONLY_RIGHT: { icon: fas.faArrowRight, color: 'orange' },
  MATCH: { icon: fas.faCheck, color: 'green' },
};

// Most severe first: two values that disagree outrank a value present on only one side
const SEVERITY = ['MISMATCH', 'MISSING', 'ONLY_LEFT', 'ONLY_RIGHT', 'MATCH'];

// Producers use free-form keys (e.g. MISSING_INC_COND), so each is folded onto one of the statuses above
const statusOf = (key) => {
  if (STATUS_ICONS[key]) return key;
  return key.includes('MISSING') ? 'MISSING' : 'MATCH';
};

// Expects matchRes to be a JSON string of status key to message
export const MatchCellRenderer = ({ data }) => {
  if (!data?.matchRes) return '';

  const matchRes = JSON.parse(data.matchRes);

  let status = 'MATCH';
  const messages = [];
  for (const [key, message] of Object.entries(matchRes)) {
    const entryStatus = statusOf(key);
    if (SEVERITY.indexOf(entryStatus) < SEVERITY.indexOf(status)) status = entryStatus;
    if (entryStatus !== 'MATCH' && message) messages.push(message);
  }

  const tooltipLines = messages.length > 0 ? messages : ['Matching'];
  const { icon, color } = STATUS_ICONS[status];

  return (
    <Tooltip
      arrow
      title={tooltipLines.map((line, idx) => (
        <div key={idx}>{line}</div>
      ))}
    >
      <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
        <FontAwesomeIcon icon={icon} style={{ color }} />
      </Box>
    </Tooltip>
  );
};
